import { useState, useEffect } from 'react';
import RtbPixel from '../../shared/RtbPixel';
import { useCurrentUser } from '../../hooks';

export const useExportData = (AdMarkupService, creative) => {
  const [exportContent, setExportContent] = useState('');
  const currentUser = useCurrentUser();

  useEffect(() => {
    if (rtbVersion() === '2.3' && creative.rtb_pixel) {
      let exportUrl;
      if (currentUser && currentUser.featureEnabled('new_2_3_asset_swap')) {
        exportUrl = creative.assetSwapUrl;
      } else {
        exportUrl = RtbPixel.format('banner', creative.rtb_pixel.pixel_key);
      }
      setExportContent(exportUrl);
    } else if (rtbVersion() === '2.2') {
      setAdMarkup();
    }
  }, [currentUser, creative]);

  const rtbVersion = () => {
    // default to 2.3 export, to backsupport creatives made
    // before DSP was persisted onto creatives
    return creative.dsp ? creative.dsp.rtb_version : '2.3';
  };

  const setAdMarkup = () => {
    const creativePayload = {
      ...creative,
      contentUrl:
        creative.mediaUrl ||
        `https://sfa.sharethrough.com/trackable_redirect/2_2_banner_workaround_${creative.id}`,
      brandLogoUrl: 'https://legacy-design-assets.s3.amazonaws.com/images/favicon.png',
      headline: creative.headline,
      thumbnailUrl:
        'https://s3.amazonaws.com/bakery-production.sharethrough.com/paperclip-assets/creative_workflow/creative_thumbnails/78638/images/original/sharethrough-og-hero.jpg?w=318&h=210&auto=format&fit=crop&dpr=1'
    };

    AdMarkupService.generate(creativePayload)
      .then(markup => {
        setExportContent(markup);
      })
      .catch(error => {
        /* eslint-disable no-console */
        console.warn(error.message);
      });
  };

  return {
    exportContent,
    rtbVersion
  };
};
